var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#001e50;}.b,.d{fill:#00b0f0;}.c{fill:none;stroke:#00b0f0;stroke-width:1.2px;}.d{font-size:9px;font-family:Helvetica-Bold, Helvetica;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 54,
    height: 54,
    rx: 27,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 23.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.755,26.845a5.357,5.357,0,0,1-2.991,3.039,5.81,5.81,0,0,1-1.364.345,6.3,6.3,0,0,1-.845.066,5.413,5.413,0,0,1-4.737-2.524h3.31l.736-.88,1.481-1.785a.956.956,0,0,0,.055-1.131.44.44,0,0,0-.055-.084l-.727-.88-1.49-1.785h-3.31A5.466,5.466,0,0,1,17.555,18.7a5.713,5.713,0,0,1,2.618.626,5.628,5.628,0,0,1,.49-1.122,6.91,6.91,0,0,0-3.108-.72A6.629,6.629,0,0,0,11,22.47h4.545l1.219,1.43.5.6-1.719,2.03H11a6.294,6.294,0,0,0,.455,1.243,6.551,6.551,0,0,0,6.1,3.74,7.472,7.472,0,0,0,1.818-.234L24.1,36.138a3.12,3.12,0,0,0,4.545,0l.182-.177a3.349,3.349,0,0,0,0-4.675l-4.119-4.235a5.776,5.776,0,0,1-1.818-.664c-.073.178-.073.318-.136.458Zm5.79,6.8a2.05,2.05,0,0,1-.572,1.44l-.182.177a1.933,1.933,0,0,1-2.8,0l-4.327-4.45a6.454,6.454,0,0,0,2.99-3.038L27.973,32.2a2.053,2.053,0,0,1,.573,1.44Z",
    transform: "translate(-11 -17.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.455,34.586a.935.935,0,1,0-.91-.935A.922.922,0,0,0,26.455,34.586Z",
    transform: "translate(-11 -17.482)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 18.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(4.825 9.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.77e3e6c9735ae4a22e719f14cb4f376e.svg";
export { ForwardRef as ReactComponent };